import React, { useMemo, useState } from "react";
import { TableSection } from "features/Research/v2/components/StockDetailPage/StockDetailPage.styles";
import { Text } from "style/v2/components/Typography";
import { Card, CardHeader, CardContent } from "./RecentTransactions.styles";
import { columns } from "./columns";
import PropTypes from "prop-types";
import { getStockCompanyIcon } from "utils/index";
import { TRADE_SIDE } from "utils/constants";
import { Table } from "components/Table";
import { useAuthorOrderHistory } from "features/Strategy/hook";
import AllTransactionsModal from "features/Explore/v2/Components/AllTransactionsModal";

const RecentTransactions = ({ strategyId: propStrategyId }) => {
  const strategyId = propStrategyId;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, isLoading } = useAuthorOrderHistory(strategyId);

  const transactions = useMemo(() => {
    if (!data?.pages) return [];

    return data.pages.flatMap(
      (page) =>
        page.data?.map((item) => {
          const BUY = TRADE_SIDE.BUY.toUpperCase();
          return {
            ...item,
            id: item.order_id,
            asset: {
              symbol: item.universal_symbol?.symbol || "--",
              name: item.universal_symbol?.symbol || "--",
              imageUrl: getStockCompanyIcon(item.universal_symbol?.symbol),
            },
            type: item.action === BUY ? "Buy" : "Sell",
            executionPrice: item.execution_price || 0,
            shares: item.filled_quantity ?? item.quantity ?? 0,
            total:
              item.action === BUY
                ? Math.abs(item.total || 0)
                : -Math.abs(item.total || 0),
            date: item.date || "N/A",
          };
        }) || []
    );
  }, [data]);

  const limitedTransactions = useMemo(() => {
    return transactions.slice(0, 5);
  }, [transactions]);

  const handleShowMore = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  if (data?.pages?.flatMap((page) => page.data || []).length === 0) return null;

  return (
    <>
      <TableSection>
        <Card>
          <CardHeader>
            <Text variant="cardHeading" weight="500" as="h3">
              Recent transactions
            </Text>
            <a href="#" onClick={handleShowMore}>
              Show more
            </a>
          </CardHeader>
          <CardContent>
            <Table
              data={limitedTransactions}
              columns={columns}
              isLoading={isLoading}
              notFoundText="No recent transactions data available"
              showPagination={false}
            />
          </CardContent>
        </Card>
      </TableSection>

      <AllTransactionsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        strategyId={strategyId}
      />
    </>
  );
};

RecentTransactions.propTypes = {
  strategyId: PropTypes.string,
};

export default RecentTransactions;
